import { gql } from '@apollo/client';
import { Commande } from '../commande/commande.fragments';

export const UserInfo = {
  fragments: {
    account: gql`
      fragment Account on UsersPermissionsUser {
        username
        firstname
        lastname
        email
        tel
        mdp
        shop
        confirmed
        options
        notes {
          data {
            id
            attributes {
              createdAt
              updatedAt
              nbvente
            }
          }
        }
      }
    `,
    avatar: gql`
      fragment Avatar on UsersPermissionsUser {
        avatar {
          data {
            id
            attributes {
              name
              media {
                data {
                  id
                  attributes {
                    url
                  }
                }
              }
            }
          }
        }
      }
    `,
    classe: gql`
      fragment Classe on Classe {
        debut
        fin
        name
        operationid
        filliere {
          data {
            id
            attributes {
              name
            }
          }
        }
        lycee {
          data {
            id
            attributes {
              name
              academie {
                data {
                  id
                  attributes {
                    name
                  }
                }
              }
            }
          }
        }
        niveau {
          data {
            id
            attributes {
              name
            }
          }
        }
      }
    `,
    commandes: gql`
      fragment Commandes on UsersPermissionsUser {
        commandes(sort: "createdAt:desc") {
          data {
            attributes {
              ...DetailsCommande
            }
          }
        }
      }
      ${Commande.fragments.detailsCommande}
    `,
    publicInfo: gql`
      fragment PublicInfo on UsersPermissionsUser {
        firstname
        lastname
        email
      }
    `
  }
};
